// ============================================================
// BARBER STEAMER — Arquivo central de conteúdo (site-config)
// Edite aqui textos, telefone, especificações e IDs de tracking
// sem precisar tocar nos componentes.
// ============================================================

export const site = {
  brandName: "Barber Steamer",
  companyName: "Frezza Cosméticos Eireli - ME",
  cnpj: "04.891.387/0001-74",
  location: "Jundiaí – SP",
  whatsappNumber: "5511942434000",
  whatsappDisplay: "(11) 94243-4000",
  responsible: "Roberto Nascimento",
  foundedYear: 2016,

  // Preencha os IDs para ativar GA4 / Google Ads / Meta Pixel.
  // Enquanto vazios, nenhum script de terceiros é carregado.
  tracking: {
    ga4: "", // ex: "G-XXXXXXXXXX"
    googleAds: "", // ex: "AW-XXXXXXXXX"
    metaPixel: "", // ex: "123456789012345"
  },

  assets: {
    bgVideo: "/assets/barber-steamer-bg.mp4",
    bgPoster: "/assets/barber-steamer-poster.jpg",
    demoVideo: "/assets/barber-steamer-demo-web.mp4",
    product: "/assets/barber-steamer-product.webp",
    founder: "/assets/founder-novo.webp",
    logo: "/assets/logo-barber-steamer.png",
    cutout: "/assets/produto-recorte.webp",
    sensory: "/assets/sensory-toalha.webp",
    modelMesa: [
      "/assets/mesa-frente.webp",
      "/assets/steamer-interior.webp",
    ],
    modelTripe: [
      "/assets/tripe-frente.webp",
      "/assets/tripe-traseira.webp",
      "/assets/roberto-barber-steamer.webp",
    ],
  },

  // Mensagens pré-preenchidas por CTA (encode feito automaticamente)
  messages: {
    hero: "Olá! Conheci o Barber Steamer pelo site e gostaria de receber informações sobre valores e condições.",
    menu: "Olá! Conheci o Barber Steamer pelo site e gostaria de receber informações sobre valores e condições.",
    modelTable: "Olá! Gostaria de receber informações sobre o Barber Steamer modelo de mesa.",
    modelTripod: "Olá! Gostaria de receber informações sobre o Barber Steamer com tripé.",
    personalization: "Olá! Gostaria de personalizar um Barber Steamer com a logo da minha barbearia.",
    shipping: "Olá! Gostaria de consultar entrega do Barber Steamer para minha cidade.",
    floating: "Olá! Conheci o Barber Steamer pelo site e gostaria de receber mais informações sobre o equipamento, modelos, valores e entrega.",
    final: "Olá! Tenho interesse no Barber Steamer e gostaria de falar com um especialista.",
  },

  topBar: ["Produzido no Brasil", "Envio para todo o Brasil", "12 meses de garantia"],

  hero: {
    lines: [
      "TOALHAS QUENTES.",
      "MAIS AGILIDADE.",
      "UMA EXPERIÊNCIA DE BARBEARIA",
    ],
    accentLine: "em outro nível.",
    subtitle:
      "O Barber Steamer prepara até 20 toalhas quentes e umedecidas por vapor, ajudando sua barbearia a ganhar praticidade, organização e profissionalismo na barboterapia.",
    indicators: [
      { icon: "Layers", label: "Até 20 toalhas" },
      { icon: "Droplets", label: "Reservatório de 4 litros" },
      { icon: "Wind", label: "Aquecimento por vapor" },
      { icon: "MapPin", label: "Produzido no Brasil" },
      { icon: "ShieldCheck", label: "12 meses de garantia" },
    ],
  },

  marquee: [
    "Toalha quente",
    "Vapor",
    "Barboterapia",
    "Praticidade",
    "Economia",
    "Durabilidade",
    "Produzido no Brasil",
  ],

  problems: [
    {
      icon: "Zap",
      title: "Micro-ondas",
      text: "Preparação individual e interrupções durante o trabalho.",
    },
    {
      icon: "CookingPot",
      title: "Panelas e recipientes",
      text: "Processos improvisados ocupando espaço e exigindo atenção.",
    },
    {
      icon: "Repeat",
      title: "Métodos convencionais",
      text: "Mais etapas para preparar toalhas ao longo do atendimento.",
    },
  ],

  steps: [
    {
      number: "01",
      title: "Abasteça",
      text: "Reservatório com capacidade de até 4 litros.",
    },
    {
      number: "02",
      title: "Prepare as toalhas",
      text: "Coloque as toalhas de rosto no equipamento. Capacidade para até 20 toalhas.",
    },
    {
      number: "03",
      title: "Deixe o vapor trabalhar",
      text: "O sistema aquece e umedece as toalhas, deixando-as preparadas para a barboterapia.",
    },
  ],
  stepsNote: "A água atinge aproximadamente 70 °C em cerca de 20 minutos.",

  benefits: [
    {
      icon: "Zap",
      title: "Mais agilidade",
      text: "Prepare várias toalhas ao mesmo tempo e reduza interrupções durante os atendimentos.",
    },
    {
      icon: "Layers",
      title: "Até 20 toalhas",
      text: "Capacidade pensada para atender a rotina de uma barbearia profissional.",
    },
    {
      icon: "Box",
      title: "Mais organização",
      text: "Centralize o preparo das toalhas em um equipamento desenvolvido para essa finalidade.",
    },
    {
      icon: "BadgeCheck",
      title: "Padronização",
      text: "Mantenha uma rotina de preparo mais consistente durante os atendimentos.",
    },
    {
      icon: "Sparkles",
      title: "Experiência do cliente",
      text: "Ofereça uma toalha quente e umedecida durante a barboterapia.",
    },
    {
      icon: "Flower2",
      title: "Aromatização",
      text: "Possibilidade de utilizar aromatizadores recomendados pelo fabricante.",
    },
    {
      icon: "Brush",
      title: "Personalização",
      text: "Possibilidade de personalizar o equipamento com a identidade visual da própria barbearia.",
    },
    {
      icon: "TrendingUp",
      title: "Produtividade",
      text: "Deixe toalhas preparadas para reduzir interrupções durante o atendimento.",
    },
  ],

  sensory: {
    words: ["Calor", "Vapor", "Aroma", "Conforto", "Experiência"],
    text: "A toalha quente já é um dos momentos mais marcantes da barboterapia. O Barber Steamer ajuda sua barbearia a entregar essa experiência de maneira muito mais organizada e profissional.",
    aromaText:
      "Além de preparar as toalhas quentes e umedecidas, é possível trabalhar com aromatização, ajudando a criar uma experiência sensorial diferenciada durante o atendimento — seguindo as orientações do fabricante.",
  },

  models: [
    {
      id: "mesa",
      name: "Barber Steamer — Mesa",
      height: "410 mm de altura",
      diameter: "390 mm de diâmetro",
      weight: "15 kg",
      note: "Ideal para utilização sobre superfície apropriada.",
      cta: "Consultar modelo de mesa",
      messageKey: "modelTable",
      location: "model_table",
    },
    {
      id: "tripe",
      name: "Barber Steamer — Com Tripé",
      height: "1.100 mm de altura",
      diameter: "390 mm de diâmetro",
      weight: "18 kg",
      note: "Solução com estrutura própria para posicionamento.",
      cta: "Consultar modelo com tripé",
      messageKey: "modelTripod",
      location: "model_tripod",
    },
  ],

  comparison: {
    improvised: [
      "Preparação individual",
      "Mais interrupções",
      "Equipamentos não específicos para barbearia",
      "Processo descentralizado",
      "Pouca padronização",
    ],
    steamer: [
      "Até 20 toalhas",
      "Equipamento desenvolvido para barbearias",
      "Sistema de vapor",
      "Reservatório de 4 litros",
      "Controle de temperatura",
      "Possibilidade de aromatização",
      "Possibilidade de personalização",
    ],
  },

  specs: [
    ["Capacidade", "Até 20 toalhas"],
    ["Reservatório", "4 litros"],
    ["Voltagem", "220 V"],
    ["Potência", "1.250 W"],
    ["Tempo para água atingir 70 °C", "Aproximadamente 20 minutos"],
    ["Temperatura de funcionamento", "Até aproximadamente 80 °C"],
    ["Estrutura interna", "Aço inoxidável 304"],
    [
      "Estrutura externa",
      "Aço carbono galvanizado com pintura eletrostática de alta resistência à corrosão",
    ],
    ["Sistema", "Vapor"],
    ["Versão Mesa", "15 kg"],
    ["Versão com Tripé", "18 kg"],
    ["Garantia", "12 meses contra defeitos de fabricação"],
    ["Produção", "Brasil"],
  ],
  // NOTA: informação de consumo de energia ("~6,0 kWh/h por mês") possui
  // unidade inconsistente. NÃO publicar até confirmação do fabricante.

  safety: [
    "Controlador de temperatura",
    "Indicador digital",
    "Isolamento térmico",
    "Sensores de segurança",
    "Funcionamento intermitente através do controlador de temperatura",
  ],

  pillars: ["Praticidade", "Economia", "Durabilidade"],
  story:
    "Em 2016, visitando barbearias, identificamos que muitos profissionais precisavam improvisar para preparar toalhas quentes: micro-ondas, cafeteiras, panelas e aquecedores adaptados. Dessa necessidade nasceu o Barber Steamer — um equipamento desenvolvido especificamente para a rotina profissional das barbearias.",
  purpose:
    "Criar produtos inovadores para melhorar a rotina dos profissionais.",

  audience: [
    { icon: "Scissors", label: "Barbeiros autônomos" },
    { icon: "Store", label: "Barbearias" },
    { icon: "Network", label: "Redes de barbearias" },
    { icon: "Building2", label: "Salões masculinos" },
    { icon: "Flame", label: "Espaços de barboterapia" },
    { icon: "GraduationCap", label: "Escolas de barbeiros" },
    { icon: "Package", label: "Distribuidores" },
  ],

  warranty: [
    { icon: "ShieldCheck", title: "12 meses de garantia" },
    { icon: "Wrench", title: "Peças de reposição" },
    { icon: "MessageCircle", title: "Suporte pelo WhatsApp" },
    { icon: "Gauge", title: "Assistência técnica" },
  ],

  shipping: {
    items: [
      { icon: "Truck", title: "Envio para todo o Brasil", text: "Prazo aproximado de 15 dias." },
      { icon: "Clock", title: "Disponibilidade", text: "Consultar disponibilidade no momento da compra." },
      { icon: "MapPin", title: "Retirada presencial", text: "Jundiaí – SP e região." },
    ],
    disclaimer:
      "Condições, prazo definitivo, disponibilidade e transportadora devem ser confirmados no momento da compra.",
  },

  // PLACEHOLDER: substituir por depoimentos REAIS (foto, nome, barbearia,
  // cidade, depoimento). Não publicar depoimentos inventados.
  testimonials: [],

  faq: [
    {
      q: "Quantas toalhas cabem no Barber Steamer?",
      a: "Até 20 toalhas de rosto.",
    },
    {
      q: "Quanto tempo demora para aquecer?",
      a: "A água atinge aproximadamente 70 °C em cerca de 20 minutos.",
    },
    {
      q: "Qual é a voltagem?",
      a: "O modelo informado atualmente é 220 V.",
    },
    {
      q: "Qual a capacidade do reservatório?",
      a: "4 litros.",
    },
    {
      q: "Precisa de instalação?",
      a: "É necessário ter ponto elétrico compatível com as especificações fornecidas pelo fabricante. Siga sempre o manual e as orientações de utilização.",
    },
    {
      q: "Pode utilizar aromatizador?",
      a: "Sim, seguindo as recomendações do fabricante.",
    },
    {
      q: "Possui garantia?",
      a: "Sim. São 12 meses contra defeitos de fabricação.",
    },
    {
      q: "Existe assistência técnica?",
      a: "Sim. O produto possui suporte pós-venda.",
    },
    {
      q: "Existem peças de reposição?",
      a: "Sim.",
    },
    {
      q: "Entrega para todo o Brasil?",
      a: "Sim.",
    },
    {
      q: "Posso retirar pessoalmente?",
      a: "Consulte a disponibilidade para retirada em Jundiaí – SP e região.",
    },
    {
      q: "Qual a diferença entre os modelos?",
      a: "Existem versões de mesa (410 mm de altura, 15 kg) e com tripé (1.100 mm de altura, 18 kg). Consulte dimensões, peso e fotografias de cada uma na seção de modelos.",
    },
    {
      q: "Pode colocar a logo da minha barbearia?",
      a: "Sim. Existe a possibilidade de personalização do equipamento com a identidade visual da sua barbearia.",
    },
  ],
};
